import React, { useState,useEffect } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
} from "@mui/material";
import styles from "../../../styles.module.css";

// import { useDispatch, useSelector } from "react-redux";
// import { getEmptyCylinderList } from "../../../actions/actions";

import {
  Breadcrumb,
  StyledTableCell,
  StyledTableRow,
} from "../../reusableComponent/Reusables";

import HeaderSection from "../../reusableComponent/HeaderSection";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";

const EmptyCylinderInv = () => {
  // const dispatch = useDispatch();

  const [searchKey, setSearchKey] = useState("");
    // const [total_count,setTotalCount]=useState(null)
    // useEffect(() => {
    //   setTotalCount(rows[0]?.totalCount);
    // }, [rows]);
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: 10,
  });

  const [successMessage, setSuccessMessage] = useState(null);

  const mockRows = [
    {
      cylinder_code: "EC001",
      product_name: "Oxygen",
      product_code: "OX100",
      count: 15,
      plant: "Plant A",
    },
    {
      cylinder_code: "EC002",
      product_name: "Nitrogen",
      product_code: "N200",
      count: 25,
      plant: "Plant B",
    },
    // Add more rows if needed
  ];

  const handleChangePage = (event, newPage) => {
    setController((prev) => ({ ...prev, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setController({
      ...controller,
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
    });
  };

  const handleSearch = (e) => {
    setSearchKey(e.target.value);
    // Normally you'd filter or fetch based on this value
  };

  // Pagination logic
  const start = controller.page * controller.rowsPerPage;
  const end = start + controller.rowsPerPage;
  const paginatedRows = mockRows.slice(start, end);
  const paginationInfo = `${start + 1}-${Math.min(end, mockRows.length)} of ${mockRows.length}`;

  return (
    <Box className={styles.cts_page} sx={{ padding: "0px !important", margin: "0px !important" }}>
      <Box className={styles.body}>
        <Breadcrumb routeSegments={[{ name: "Empty Cylinder Report" }]} />

        <HeaderSection
          title="Empty Cylinder Report"
          searchKey={searchKey}
          handleSearch={handleSearch}
          sortedRows={mockRows}
          fields={[]}
          labels={[]}
          filename="Empty Cylinder Report"
          paginationInfo={paginationInfo}
          controller={controller}
          handleChangePage={handleChangePage}
          showAddButton={false}
        />

        <Paper sx={{ width: "100%" }}>
          <TableContainer component={Paper} className={styles.list_tbl_container}>
            <Table size="small" stickyHeader>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell align="left">Cylinder Code</StyledTableCell>
                  <StyledTableCell align="left">Product Name</StyledTableCell>
                  <StyledTableCell align="left">Product Code</StyledTableCell>
                  <StyledTableCell align="right">Count</StyledTableCell>
                  <StyledTableCell align="left">Plant</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody sx={{ backgroundColor: "#fff" }}>
                {paginatedRows.map((row, index) => (
                  <StyledTableRow key={index}>
                    <StyledTableCell align="left">{row.cylinder_code}</StyledTableCell>
                    <StyledTableCell align="left">{row.product_name}</StyledTableCell>
                    <StyledTableCell align="left">{row.product_code}</StyledTableCell>
                    <StyledTableCell align="right">{row.count}</StyledTableCell>
                    <StyledTableCell align="left">{row.plant}</StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            component="div"
            count={mockRows.length}
            page={controller.page}
            onPageChange={handleChangePage}
            rowsPerPage={controller.rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>

        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== "clickaway") {
              setSuccessMessage("");
            }
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </Box>
  );
};

export default EmptyCylinderInv;
